import { apiUrl, apiUrl2 } from '../../../settings'

export const forexBonusDashboardUrl = () => {
  return apiUrl2 + '/forex-bonus-dashboard'
}

export const bonusTransactionListUrl = () => {
  return apiUrl2 + '/forex/bonusTransactionList'
}

export const loadCurrentBalanceUrl = () => {
  return apiUrl2 + '/forex/load-current-balance'
}

export const forexCommissionWithdrawalUrl = () => {
  return apiUrl2 + '/forex/forex-commission-withdrawal'
}

export const forexDashboardGraphUrl = () => {
  return apiUrl2 + '/forex/dashboard-graph'
}

export const addWithdrawalIssueUrl = () => {
  return apiUrl2 + '/withdrawalIssue/add'
}

export const getWithdrawalIssues = () => {
  return apiUrl2 + '/withdrawalIssue/getAll'
}

export const updateWithdrawalStatus = () => {
  return apiUrl2 + '/withdrawalIssue/updateStatus'
}
